import is from 'typescript-styled-is'
import styled from '../../../../theme'

const DatePickerHeader = styled.div<IDatePickerHeaderProps>`
  position: relative;
  background: #00a541;
  transition: width 0.8s;
  border-radius: 10px 10px 0px 0px;
  color: #fff;

  ${is('isCenterOnMobile')`
  border-radius: 0px 0px 0px 0px;
  `};

  height: 96px;
  ${is('sized')`
    height: 60px;
  `}
`

export default DatePickerHeader

export interface IDatePickerHeaderProps {
  sized?: boolean
  isCenterOnMobile?: boolean
}
